import chalk from 'chalk';
import log from 'loglevel';
import prefix from 'loglevel-plugin-prefix';

const colors = {
    TRACE: chalk.magenta,
    DEBUG: chalk.cyan,
    INFO: chalk.blue,
    WARN: chalk.yellow,
    ERROR: chalk.red,
};

const logger = {
    initialize: () => {
        const getEnabled = () => {
            const val = window.localStorage.getItem("loglevel",);
            return val && val !== "SILENT";
        }
        const setEnabled = (enabled) => {
            if (enabled) log.enableAll();
            else log.disableAll();
        }

        setEnabled(getEnabled());
        prefix.reg(log);
        prefix.apply(log, {
            format(level, name, timestamp) {
                const timestampFormat = chalk.gray(`[${timestamp}]`);
                const levelFormat = colors[level.toUpperCase()](level); 
                if (name !== 'root') {
                    const nameFormat = chalk.green(`${name}:`);
                    return `${timestampFormat} ${levelFormat} ${nameFormat}`;
                }
                return `${timestampFormat} ${levelFormat}:`;
            },
        });

        window.enableLogger = (enabled) => {
            setEnabled(enabled);
            return `=====[${enabled ? "Enable Logger" : "Disable Logger"}]=====`;
        };

        return { setEnabled };
    }
}

export default logger;